import SEO from 'components/SEO';
import LoadableContentSpinner from 'components/Universal/LoadableContentSpinner';
import HeaderContext from 'providers/HeaderProvider';
import ThemeContext from 'providers/ThemeProvider';
import React, { useContext, useEffect } from 'react';
import loadable from '@react-loadable/revised'

const CoreTemplate = loadable({
	loader: () => import('components/Templates/offer/CoreTemplate'),
	loading: LoadableContentSpinner
});

export default function calculatorOffer() {
	const { setHeader } = useContext(HeaderContext);
	const { setPrimaryColor } = useContext(ThemeContext);

	useEffect(() => {
		setHeader({ title: 'Oferta Selekt', isSelect: true });
		setPrimaryColor('#3B81B9');
	}, []);


	return (
		<div>
			<SEO
				title='Indywidualna wycena kosztu faktoringu zagranicznego. Kredyt walutowy dla firm. Kalkulator oferty 100% online.'
				keywords='faktoring eksportowy, kredyt walutowy, kredyt walutowy dla firm, koszt faktoringu, faktoring koszt'
				description='Dopasuj ofertę do Twoich potrzeb. Ty decydujesz ile płacisz. Indywidulane podejście. Stawki wykupu od 0,79%. Bezpłatnie sprawdzimy Twoich kontrahentów. Pieniądze wypłacimy natychmiast. EUR, USD, CNY, SEK. Oferta w 15 sekund. Płynność dla eksporterów. Faktoring zagraniczny.'
			/>

			<CoreTemplate />
		</div>
	);
}
